// extracted by mini-css-extract-plugin
export default {"container":"container__VFheFnW0","header":"header__lZWpB__t","body":"body__YRHl9Non","actions":"actions__jAOQasLo","image":"image__XAfm7f_F"};